import { styled } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const JobsCont = styled('div')(({ theme }) => ({
  bachgroundColor: theme.palette.background.default,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  height: '100vh',
  // padding: '0 20px 20px',
}));
